import React, { createContext, useContext, useEffect, useState } from "react";
import { navigate } from "../hooks/useT";

const FastSpringContext = createContext();

export const useFastSpring = () => {
  return useContext(FastSpringContext);
};

export const FastSpringProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [data, setData] = useState({});

  // Fills up products array when SBL loads
  useEffect(() => {
    const fastSpringCallBack = (data) => {
      setData(data);
      if (data && data.groups) {
        const newProducts = data.groups
          .filter((group) => group.items && Array.isArray(group.items))
          .flatMap((group) => group.items);
        setProducts(newProducts);
      }
    };

    // Redirects upon closing the popup
    window.onFSPopupClosed = function (orderReference) {
      if (window.fastspring && window.fastspring.builder) {
        window.fastspring.builder.reset();
      }

      if (orderReference && orderReference.id) {
        navigate("/buy/thankyou", {
          state: {
            data: {
              license: orderReference.items[0].product,
              orderref: orderReference.reference,
              payment: orderReference.payment.type,
              date: orderReference.date,
              price: orderReference.totalDisplay,
              quantity: orderReference.items[0].quantity,
              email: orderReference.email,
            },
          },
        });
      }
    };
    const addSBL = () => {
      const scriptId = "fsc-api";
      const existingScript = document.getElementById(scriptId);
      if (!existingScript) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = scriptId;
        script.setAttribute("data-continuous", "true");
        script.src =
          "https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js";

        if (localStorage.getItem("ORDER_TEST")) {
          script.dataset.storefront = "ngwin.test.onfastspring.com/popup-ngwin";
        } else {
          script.dataset.storefront = "ngwin.onfastspring.com/popup-ngwin";
        }
        if (typeof window !== "undefined") {
          window.fastSpringCallBack = fastSpringCallBack;
        }
        script.setAttribute("data-data-callback", "fastSpringCallBack");
        script.setAttribute("data-popup-webhook-received", "onFSPopupClosed");

        document.head.appendChild(script);
      }
    };
    // Load SBL consistently
    addSBL();
  });

  return (
    <FastSpringContext.Provider value={{ products, data }}>
      {children}
    </FastSpringContext.Provider>
  );
};
